import SignInOrJoinButton from "../../../presentational/customerItems/SignInOrJoinButton";
import Login from "../../common/Login";

const ConnectedSignInOrJoinButton = props => (
  <Login {...props} PresentationComponent={SignInOrJoinButton} />
);

export default ConnectedSignInOrJoinButton;
